import Image from 'next/image';
import React from 'react';
import term from './term.png';
import tax from './tax.png';
import life from './life.png';

export const LifeMidSection = () => {
  return (
    <div className="flex flex-col gap-11">
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <div className="flex flex-col justify-center gap-4">
          <h1 className="text-title-4 lg:text-title-3  font-bold">Understanding Life Insurance</h1>
          <p className="text-title-7 lg:text-title-5 prose font-medium">
            Life insurance is an agreement between the policy owner and the insurer, providing financial protection in
            the event of death or other specified events. It offers peace of mind and financial security to individuals
            and their families.
          </p>
        </div>
        <div>
          <Image src={term} alt="life insurance" />
        </div>
      </div>
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
        <div className="order-2 lg:order-1">
          <Image src={tax} alt="life insurance" />
        </div>
        <div className="order-1 flex flex-col justify-center gap-4 lg:order-2">
          <h1 className="text-title-4 lg:text-title-3  font-bold">Tax Benefit</h1>
          <p className="text-title-7 lg:text-title-5 prose font-medium">
            Section 80D, EEE, and 10D of the Income Tax Act provide tax benefits on premiums paid and benefits received
            under life insurance policies.
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <div className="flex flex-col justify-center gap-4">
          <h1 className="text-title-4 lg:text-title-3  font-bold">Why have Life Insurance</h1>
          <div className="text-title-7 lg:text-title-5 flex flex-col font-medium">
            <ul>
              <li>Protection: Safeguard your loved ones financially in case of unexpected events.</li>
              <li>Liquidity: Provide immediate access to funds for expenses or emergencies.</li>
              <li>Tax Relief: Enjoy tax benefits on premiums paid and benefits received.</li>
              <li>Financial Security: Ensure a steady income or lump sum payout when needed.</li>
            </ul>
          </div>
        </div>
        <div>
          <Image src={life} alt="life insurance" />
        </div>
      </div>
    </div>
  );
};
